import { Injectable } from '@angular/core';
import { PaetepPortalApi } from '../api/paetep-portal.api';

@Injectable()
export class PaetepPortalService {

    constructor(private paetepPortalApi: PaetepPortalApi) { }

    getPortalModuleSettings = () =>
        this.paetepPortalApi.getPortalModuleSettings();
}